import { render, staticRenderFns } from "./ModalAdminAffiliate.vue?vue&type=template&id=4f4285a6&scoped=true"
import script from "./ModalAdminAffiliate.vue?vue&type=script&lang=js"
export * from "./ModalAdminAffiliate.vue?vue&type=script&lang=js"
import style0 from "./ModalAdminAffiliate.vue?vue&type=style&index=0&id=4f4285a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4285a6",
  null
  
)

export default component.exports